import '../../common_screen/contest_details/index_web.css';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  formattedWinningsPerPosition,
  getRealBalanceObj,
  isGadgetLeague,
  isSmartPhone
} from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import { showToast } from '../../../actions/app-actions-types';
import _ from 'lodash';
import ContestDetailsWeb from './index_web';
import ContestDetailsMWeb from './index_mWeb';
import { setMyContestList } from '../../../actions/fantasy-yes-no-action-types';

const ContestDetails = () => {
  const dispatch = useDispatch();
  const { questionsList } = useSelector((state: any) => state.fantasy_yes_no);
  const [questionList, setQuestionList] = useState([]);
  const {
    gameType,
    item: matchItem,
    userId = '',
    myTeamList = [],
    fantasyMatchClick,
    getContestLeaderboard,
    getPlayerList,
    getContestUserLeaderboard,
    balanceInfo = {}
  } = useGame();
  const { teamA, teamB, status, verified = false } = matchItem;

  const balance = getRealBalanceObj(balanceInfo);
  const totalTeamsCount = myTeamList.length;

  const {
    _id: matchId = '',
    status: matchStatus = '',
    verified: matchVerifiedStatus = false,
    gameState = 0,
    contest = {},
    completed = false,
    tabType = '',
    matchDelayed = false,
    matchTeamLock = false
  } = matchItem;

  const [routes] = useState([
    { key: 'Winnings', title: 'Winnings Breakup' },
    { key: 'LeaderBoard', title: 'LeaderBoard' }
  ]);

  const [activeTab, setActiveTab] = useState(0);
  const [winningData, setWinningData] = useState([]);
  const [contestDetail, setContestDetails] = useState({});
  const [contestShare, setContestShare] = useState(false);
  const [contestLink] = useState('');
  const [contestTitle] = useState('');

  const [addCashVisible, setAddCashVisible] = useState(false);
  const [contestConfirmModal, setContestConfirmModal] = useState(false);

  const {
    _id: contestId = '',
    entryFee = 0,
    bonusPercentage,
    winningsPerPosition,
    title = '',
    description = ''
  } = contest;

  const isGadgetLeague_ = isGadgetLeague(title);

  useEffect(() => {
    getAnswerList_();
    setWinningData(formattedWinningsPerPosition(winningsPerPosition));
    setContestDetails(contest);
  }, []);

  const onPressDismissContestConfirm = () => {
    setContestConfirmModal(false);
  };

  const getAnswerList_ = () => {
    let result: any = questionsList[matchItem._id];
    let questionList = {} as any;
    let questionListById = _.groupBy(result, function (QItem: { _id: any }) {
      return QItem._id;
    });
    for (let key in questionListById) {
      // eslint-disable-next-line no-prototype-builtins
      if (questionListById.hasOwnProperty(key)) {
        questionList[key] = questionListById[key][0];
      }
    }
    setQuestionList(questionList);
  };

  const onPressShare = async () => {};

  const onChangeTabIndex = (index = 0) => {
    setActiveTab(index);
  };

  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onPressShareModalDismiss = () => {
    setContestShare(false);
  };

  const onPressDismissCashModal = () => {
    setAddCashVisible(false);
  };

  const onPressJoinContest = () => {
    dispatch(showToast('Contest Joined Successfully'));
    dispatch(setMyContestList({ contest: matchItem.contest, matchId: matchId }));
    onPressDismissContestConfirm();
  };

  const onPressJoin = () => {
    setContestConfirmModal(true);
  };

  return (
    <>
      {!isSmartPhone ? (
        <ContestDetailsWeb
          teamA={teamA}
          teamB={teamB}
          verified={verified}
          status={status}
          contestDetail={contestDetail}
          onPressShare={onPressShare}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onPressJoin={onPressJoin}
          getContestUserLeaderboard={getContestUserLeaderboard}
          getContestLeaderboard={getContestLeaderboard}
          fantasyMatchClick={fantasyMatchClick}
          completed={completed}
          contestId={contestId}
          userId={userId}
          winningsPerPosition={winningsPerPosition}
          entryFee={entryFee}
          tabType={tabType}
          matchVerifiedStatus={matchVerifiedStatus}
          bonusPercentage={bonusPercentage}
          matchId={matchId}
          getPlayerList={getPlayerList}
          matchTeamLock={matchTeamLock}
          myTeamList={myTeamList}
          isGadgetLeague_={isGadgetLeague_}
          description={description}
          questionList={questionList}
          winningData={winningData}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
          contestConfirmModal={contestConfirmModal}
          onPressDismissContestConfirm={onPressDismissContestConfirm}
          onPressJoinContest={onPressJoinContest}
          balance={balance['totalBalance']}
          addCashVisible={addCashVisible}
          onPressDismissCashModal={onPressDismissCashModal}
          routes={routes}
        />
      ) : (
        <ContestDetailsMWeb
          teamA={teamA}
          teamB={teamB}
          verified={verified}
          status={status}
          contestDetail={contestDetail}
          onPressShare={onPressShare}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onPressJoin={onPressJoin}
          getContestUserLeaderboard={getContestUserLeaderboard}
          getContestLeaderboard={getContestLeaderboard}
          fantasyMatchClick={fantasyMatchClick}
          completed={completed}
          contestId={contestId}
          userId={userId}
          winningsPerPosition={winningsPerPosition}
          entryFee={entryFee}
          tabType={tabType}
          matchVerifiedStatus={matchVerifiedStatus}
          bonusPercentage={bonusPercentage}
          matchId={matchId}
          getPlayerList={getPlayerList}
          matchTeamLock={matchTeamLock}
          myTeamList={myTeamList}
          isGadgetLeague_={isGadgetLeague_}
          description={description}
          questionList={questionList}
          winningData={winningData}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
          contestConfirmModal={contestConfirmModal}
          onPressDismissContestConfirm={onPressDismissContestConfirm}
          onPressJoinContest={onPressJoinContest}
          balance={balance}
          addCashVisible={addCashVisible}
          onPressDismissCashModal={onPressDismissCashModal}
          routes={routes}
          onChangeTabIndex={onChangeTabIndex}
          onChangeTab={onChangeTab}
          activeTab={activeTab}
        />
      )}
    </>
  );
};
export default ContestDetails;
